<template>
  <div
    id="app"
    class="site-layout"
    :class="{
      'menu-collapsed': isMenuCollapsed,
      'is-authorized': isLoggedIn,
    }"
  >
    <notifications position="bottom center" />
    <header
      v-if="isLoggedIn"
      id="header"
      class="site-header"
    >
      <a
        href="#"
        class="burger-link"
        @click.prevent="isMenuCollapsed = !isMenuCollapsed"
      >
        <img
          :src="require('@/assets/icons/icon-burger.svg')"
          alt=""
          width="23"
          height="16"
          class="burger-img"
        >
      </a>
      <router-link
        to="/"
        class="logo-link"
      >
        <img
          :src="require('@/assets/logo.svg')"
          alt="Gimmonix"
          class="logo-img"
        >
      </router-link>
      <chip class="demo">
        DEMO
      </chip>
      <div class="user-panel">
        <div class="user-panel__visual">
          <span class="userpic">
            <img
              src="https://www.fillmurray.com/66/66"
              alt="Drew Speck"
              width="32"
              height="32"
            >
          </span>
        </div>
        <div class="user-panel__info">
          <strong class="user-panel__name">Drew Speck</strong>
          <em class="user-panel__email">drew@gimmonix.com</em>
        </div>
        <div class="user-panel__settings">
          <a
            href="#"
            @click.prevent="logout"
          >
            <img
              :src="require('@/assets/icons/icon-settings.svg')"
              alt="Settings"
              width="14"
              height="14"
            >
          </a>
        </div>
      </div>
    </header>
    <nav
      v-if="isLoggedIn"
      id="nav"
      class="site-nav"
    >
      <ul class="site-nav__list">
        <li class="site-nav__item">
          <router-link
            :to="{ name: 'search2' }"
            class="site-nav__link"
            title="Search all filters"
          >
            <span
              class="icon"
              v-html="icons.IconSearchV2"
            />
            <span class="title">Search all filters</span>
          </router-link>
        </li>
        <li class="site-nav__item">
          <router-link
            :to="{ name: 'search' }"
            class="site-nav__link"
            title="Search Tabs view"
          >
            <span
              class="icon"
              v-html="icons.IconSearchV1"
            />
            <span class="title">Search Tabs view</span>
          </router-link>
        </li>
        <li class="site-nav__item">
          <router-link
            :to="{
              name: 'content',
              params: {
                id: getRandomElement(hotelsIds),
              },
            }"
            title="Content & Rates"
            class="site-nav__link"
            active-class=""
            :class="{
              'router-link-active': this.$route.name === 'content' && !this.$route.query.abs,
            }"
          >
            <span
              class="icon"
              v-html="icons.IconContent"
            />
            <span class="title">Content & Rates</span>
          </router-link>
        </li>
        <li class="site-nav__item">
          <router-link
            to="/post-booking"
            class="site-nav__link"
            title="Post Booking"
          >
            <span
              class="icon"
              v-html="icons.IconPostBooking"
            />
            <span class="title">Post Booking</span>
          </router-link>
        </li>
        <li class="site-nav__item">
          <router-link
            :to="{
              name: 'content',
              params: {
                // id: getRandomElement(hotelsIds),
                id: 4082283,
              },
              query: {
                abs: true,
              },
            }"
            title="ABS"
            class="site-nav__link"
            active-class=""
            :class="{
              'router-link-active': this.$route.name === 'content' && this.$route.query.abs,
            }"
          >
            <span
              class="icon"
              v-html="icons.IconAbs"
            />
            <span class="title">ABS</span>
          </router-link>
        </li>
      </ul>
    </nav>
    <main
      id="main"
      class="site-main"
    >
      <router-view />
    </main>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getRandomElement } from '@/helpers';

import IconSearchV1 from '!svg-inline-loader?removeTags=true!@/assets/icons/icon-search-v1.svg';
import IconSearchV2 from '!svg-inline-loader?removeTags=true!@/assets/icons/icon-search-v2.svg';
import IconContent from '!svg-inline-loader?removeTags=true!@/assets/icons/icon-content.svg';
import IconPostBooking from '!svg-inline-loader?removeTags=true!@/assets/icons/icon-post-booking.svg';
import IconAbs from '!svg-inline-loader?removeTags=true!@/assets/icons/icon-abs.svg';

export default {
  name: 'app',
  data() {
    let isMenuCollapsed = this.$ls.get('menu-collapsed');
    if (isMenuCollapsed === undefined) {
      isMenuCollapsed = this.getMenuCollapsedInitState();
    }
    return {
      isMenuCollapsed,
      isLoading: false,
      hotelsIds: null,
      icons: {
        IconSearchV1,
        IconSearchV2,
        IconContent,
        IconPostBooking,
        IconAbs,
      },
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
  },
  watch: {
    isMenuCollapsed(val) {
      this.$ls.set('menu-collapsed', val);
    },
  },
  async created() {
    this.$store.state.isLoggedIn = this.$ls.get('isLoggedIn');
    this.isLoading = true;
    const hotelsShort = await this.getHotelsShort();
    this.hotelsIds = hotelsShort.map(({ hotelId }) => hotelId);
    this.isLoading = false;
  },
  methods: {
    getRandomElement,
    ...mapActions([
      'getHotelsShort',
    ]),
    getMenuCollapsedInitState() {
      switch (this.$screen.breakpoint) {
        case 'xss':
        case 'xs':
        case 'sm':
        case 'tablet':
        case 'laptop':
          return true;
        default:
          return false;
      }
    },
    logout() {
      this.$ls.remove('isLoggedIn');
      this.$store.state.isLoggedIn = false;
      this.$router.push({
        name: 'login',
      });
    },
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
*:before,
*:after {
  box-sizing: border-box;
}
@font-face {
  font-family: 'Proxima Nova';
  src: url('/fonts/ProximaNova-Regular.woff2');
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: 'Proxima Nova';
  src: url('/fonts/ProximaNova-Bold.woff2');
  font-style: normal;
  font-weight: bold;
}
@font-face {
  font-family: 'Proxima Nova';
  src: url('/fonts/ProximaNova-Medium.woff2');
  font-style: normal;
  font-weight: 500;
}
</style>

<style lang="scss">
body {
  font-size: 14px;
  line-height: 16px;
  font-family: 'Proxima Nova', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 768px;
}

.site-layout {
  min-height: 100vh;
  position: relative;
  overflow: hidden;

  &.is-authorized {
    display: grid;
    grid-template-areas:
      'header header'
      'sidebar main';
    grid-template-columns: minmax(0, calc(575px / 2)) minmax(0, 1fr);
    grid-template-rows: min-content auto;
    &.menu-collapsed {
      grid-template-columns: auto minmax(0, 1fr);
    }
    @media screen and (max-width: 1600px) {
      grid-template-columns: auto minmax(0, 1fr);
    }
  }

  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-template-areas: 'main';
}

.site-nav {
  grid-area: sidebar;
  background: #fff;
  box-shadow: 0 2px 14px 4px rgba(50, 50, 90, 0.08);
  z-index: 1;
  position: relative;
  font-size: 14px;
  line-height: 20px;
  padding: 20px 0;

  &__link {
    display: flex;
    align-items: flex-start;
    text-decoration: none;
    font-weight: bold;
    color: #6e7c91;
    padding: 10px 28px;

    .no-touchevents &:hover {
      background: rgba(#6e7c91, 0.1);
    }
    &:active {
      background: rgba(#6e7c91, 0.1);
    }

    .icon {
      flex: 0 0 14px;
      display: flex;
      width: 14px;
      height: 14px;
      margin: 3px 0;
      svg {
        fill: #c5cbd3;
        display: block;
        width: 100%;
        height: 100%;
      }

      & + * {
        margin-left: 22px;
        display: inline-block;
        vertical-align: middle;
      }

      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }

    .title {
      flex-grow: 1;
      .site-layout.menu-collapsed & {
        display: none;
      }
    }

    &.router-link-active {
      color: #6558fe;
      svg {
        fill: #6558fe;
      }
      .site-layout.menu-collapsed & {
        background: currentColor;
        svg {
          fill: #fff;
        }
      }
    }
  }
}

.site-main {
  grid-area: main;
  background: #f7f9fc;
}

.site-header {
  grid-area: header;
  z-index: 2;
  position: relative;
  background: #fff;
}

.site-header {
  display: flex;
  align-items: center;
  padding: 22px 28px 20px;
  border-bottom: 2px solid #edf1f6;
  .demo {
    margin-left: 17px;
  }
  .logo-link {
    margin-left: 23px;
    display: flex;
    align-self: stretch;
    align-items: center;
    .logo-img {
      display: block;
    }
  }
  .burger-img {
    width: calc(24px / 2);
    height: calc(16px / 2);
  }
  .user-panel {
    margin-left: auto;
  }
}
.user-panel {
  display: flex;
  justify-content: space-between;
  border-radius: 18px 0 0 18px;
  align-items: center;
  &__visual + &__info {
    margin-left: 15px;
  }
  &__info + &__settings {
    margin-left: 5px;
    border-left: 1px solid rgba(#4b5161, 20%);
    padding-left: 14px;
    margin: 5px 0 5px 5px;
  }
  &__info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #4b5161;
  }
  &__name {
    font-size: 13px;
    line-height: 14px;
  }
  &__email {
    font-size: 10px;
    line-height: 14px;
    opacity: 0.67;
    font-style: normal;
  }
  &__settings {
    width: 14px + 14px;
    display: flex;
    align-self: stretch;
    flex-direction: column;
    justify-content: center;
    a {
      display: block;
    }
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
.logo-img {
  width: calc(168px / 2);
  height: calc(35px / 2);
}
.userpic {
  display: inline-block;
  vertical-align: middle;
  width: 36px;
  border: 2px solid #8db2f3;
  border-radius: 50%;
  overflow: hidden;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
.btn {
  background: #32325a;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  font-family: inherit;
  height: 31px;
  margin: 0;
  border: 0;
  cursor: pointer;
  border-radius: 3px;
  padding: 6px 11px 5px;
  text-transform: uppercase;
  box-shadow: 0 2px 2.5px rgba(50,50,90,0.23);
  .no-touchevents &:hover {
    background: lighten(#32325a, 10%);
  }
  &:active {
    background: darken(#32325a, 10%);
  }
}
.filters-grid {
  display: flex;
  & > * {
    flex: 1 0 0;
  }
}
.list-checkbox {
  margin: -5px;
  &__item {
    & + & {
      margin-top: 2px;
    }
  }
  &__control {
    display: flex !important;
  }
}

.vue-notification {
  border-left: none;
  background-color: #32325a;
  opacity: 0.8;
  border-radius: 3px;
  .notification-content {
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }
}
.ta-center {
  text-align: center !important;
}
.list-autocomplete-items {
  &__item + &__item {margin-top: 3px;}
}
.multiselect {
  transform: translateZ(0);
}
.multiselect__option--highlight:after,
.multiselect__option--selected:after,
.multiselect__option--selected.multiselect__option--highlight:after {
  content: none;
}
.multiselect__option--selected {
  background-color: transparent;
  color: currentColor;
  font-weight: 400;
}
.multiselect__option--highlight {
  background-color: #f8f9fc;
  color: #333;
}

.multiselect__option--highlight.multiselect__option--selected {
  background-color: #f8f9fc;
  color: #333;
}
.gallery-fade-enter-active, .gallery-fade-leave-active {
  transition: opacity 0.75s;
}
.gallery-fade-enter, .gallery-fade-leave-to {
  opacity: 0;
}

.select-transparent,
.select-blue {
  &.multiselect {
    min-height: 0;
    cursor: pointer;
  }
  &.is-slim .multiselect__tags {line-height: 21px;}
  .multiselect {
    &__tags {
      border: none;
      background-color: transparent;
      padding: 0 0 0 2px;
      border-radius: 0;
      min-height: 0;
      font-size: 15px;
      font-weight: bold;
      color: #6e7c91;
      line-height: 30px;
    }
    &__select {
      width: 30px;
      height: 100%;
      right: 0;
      padding: 0;
      top: 0;
      bottom: 0;
      &:before {
        display: none;
      }
      &:after {
        content: '';
        background-image: url('/icons/icon-arrow-down.svg');
        background-size: contain;
        width: 10px;
        height: 6px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    &__single {
      background: none;
      line-height: inherit;
      padding: 0;
      margin: 0;
      min-height: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      padding-right: 22px;
    }
    &__content-wrapper {
      min-width: 100%;
      width: auto;
    }
  }
}

.select-blue {
  .multiselect {
    &__tags {
      background-color: #32325a;
      color: #fff;
      font-size: 13px;
      line-height: 34px;
      padding-left: 12px;
      padding-right: 10px;
      border-radius: 3px;
    }
  }
}
</style>
